import { useSelector } from 'react-redux';

import { selectCompanyFeatures } from '../../redux/modules/company';

const useCompanyFeatures = (featureFlag, featureSet = null) => {
  const companyFeatures = useSelector(selectCompanyFeatures);
  const selectedCompanyFeatures = featureSet ?? companyFeatures;

  let companyHasFeature = true;
  let authorizedFeatureFlags = [];

  if (Array.isArray(featureFlag)) {
    authorizedFeatureFlags = featureFlag.reduce((flags, feature) => {
      if (selectedCompanyFeatures.length) {
        if (selectedCompanyFeatures.find(companyFeature => (companyFeature.name === feature))?.isEnabled) {
          return [...flags, feature];
        }
      }

      return flags;
    }, []);

    companyHasFeature = !!authorizedFeatureFlags.length;
  } else if (featureFlag) {
    companyHasFeature = selectedCompanyFeatures.find(feature => (feature.name === featureFlag))?.isEnabled ?? false;
    authorizedFeatureFlags = companyHasFeature ? [...authorizedFeatureFlags, featureFlag] : authorizedFeatureFlags;
  }

  return { companyHasFeature, authorizedFeatureFlags };
};

export default useCompanyFeatures;
